import { inject, Injectable } from '@angular/core';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { NavigationLink } from '../../../../elements/components/navigation-item/entities/navigation-link.entity';
import { FieldReadHelper } from '../../../../profile-form/helpers/fields/field-read.helper';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { LinkCell } from '../../components/cells/link-cell/link-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class UrlFieldColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.WIDE;
    protected readonly DISABLE_SORT: boolean = false;
    private readonly fieldReadHelper: FieldReadHelper = inject(FieldReadHelper);

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => {
            const url: string = this.fieldReadHelper.getSimpleFieldValue(profileField.FieldDefinition, record) ?? '';
            const navigationLink: NavigationLink = {
                route: url,
                target: '_blank'
            };

            return new LinkCell({
                title: url,
                navigationLink
            });
        };
    }
}
